<main class="main" id="top">
  <div class="container" data-layout="container">

    <nav class="navbar navbar-light navbar-glass navbar-top sticky-kit navbar-expand-lg">

      <button class="btn navbar-toggler-humburger-icon navbar-toggler mr-1 mr-sm-3" type="button" data-toggle="collapse" data-target="#navbarStandard" aria-controls="navbarStandard" aria-expanded="false" aria-label="Toggle Navigation"><span class="navbar-toggle-icon"><span class="toggle-line"></span></span></button>
      <a class="navbar-brand mr-0">
        <div class="d-flex align-items-center">
          <div class="logo mr-5">
            <a  routerLink="/"><img style="height:60px" src="../../../assets/img/logos/VMI_LOGO.png" /></a>
          </div>

          <div class="search-box">
         
           
          </div>
        </div>
      </a>
      <div class="collapse navbar-collapse scrollbar ml-3" id="navbarStandard">
        <ul class="navbar-nav" data-top-nav-dropdowns="data-top-nav-dropdowns">
          <span *ngFor="let menu of menus">
          <li class="nav-item" [hidden]="menu.submenus.length>0">
            <a class="nav-link " role="button" [routerLink]="menu.url">{{menu.name}}</a>
          </li>
          <li class="nav-item dropdown" [routerLinkActive]="['link-active']" [hidden]="menu.submenus.length==0 || menu.multipleRowOpe">

            <!--dropdown-on-hover-->
            <a class="nav-link dropdown-toggle" id="submenu-{{menu.name}}" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{menu.name}}</a>
            <div class="dropdown-menu dropdown-menu-card p-1" aria-labelledby="submenu-{{menu.name}}">
              <div *ngFor="let sbm of menu.submenus" [hidden]="sbm?.threemenus?.length!=0">
                <div class="bg-white rounded-soft pt-1"><a class="dropdown-item menu" [routerLink]="sbm.url">{{sbm.name}}</a></div>
                <a *ngFor="let thr of sbm.threemenus" class="nav-link  py-1 text-700 font-weight-medium" [routerLink]="thr.url">{{thr.name}}</a>
              </div>
            </div>
          </li>
          <li class="nav-item dropdown" [routerLinkActive]="['link-active']" [hidden]="menu.submenus.length==0 || !menu.multipleRowOpe">
            <!--dropdown-on-hover-->
            <a class="nav-link dropdown-toggle" id="submenu-{{menu.name}}" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{menu.name}}</a>
            <div class="dropdown-menu dropdown-menu-right dropdown-menu-card" aria-labelledby="submenu-{{menu.name}}">
              <div class="card navbar-card-pages shadow-none">
                <div class="card-body scrollbar perfect-scrollbar max-h-dropdown">
                  <img class="position-absolute b-0 r-0" src="../assets/img/illustrations/authentication-corner.png" width="130" alt="" />
                  <div *ngFor="let sbm of menu.submenus" [hidden]="sbm?.threemenus?.length!=0">
                    <a class="dropdown-item menu" [routerLink]="sbm.url">{{sbm.name}}</a>
                  </div>
                  <div class="row">
                    <div class="col-6 col-md-4" *ngFor="let sbm of menu.submenus" [hidden]="sbm?.threemenus?.length==0">
                      <div class="nav flex-column">
                        <div class="nav-link py-1 text-900 font-weight-bold mt-3" *ngIf="sbm.threemenus?.length!=0">{{sbm.name}}</div>
                        <a class="nav-link py-1 text-700 font-weight-medium" *ngIf="sbm.threemenus?.length==0" [routerLink]="sbm.url">{{sbm.name}}</a>
                        <a *ngFor="let thr of sbm.threemenus" class="nav-link menu py-1 text-700 font-weight-medium" [routerLink]="thr.url">{{thr.name}}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          </span>
        </ul>
      </div>


      <ul class="navbar-nav navbar-nav-icons ms-auto flex-row align-items-center">


        <li class="nav-item d-none d-sm-block mr-1">

          <span class="cursor-pointer fs-18" (click)="showReport();hideCollapse();" style="margin-top: -2px; padding: 0.1875rem 0.55rem;" data-toggle="tooltip" data-placement="top" title="Feedback">
            <i class="fas fa-comment-alt"></i>
          </span>

        </li>



        <li class="nav-item">
          <a class="nav-link px-0 notification-indicator notification-indicator-warning notification-indicator-fill icon-indicator "routerLink="/basket"><span class="fas fa-shopping-cart fs-4" data-fa-transform="shrink-7"></span><span class="notification-indicator-number">{{ basketCount }}</span></a>
        </li>


        <li class="nav-item dropdown">
          <a class="nav-link pr-0" id="navbarDropdownUser" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="avatar avatar-xl">
              <img class="rounded-circle" *ngIf="_authService.image()?.length>0" src="{{_authService.image()}}" />
              <span *ngIf="_authService.image()?.length==0" class="circle-user-icon"><i class="fas fa-user"></i></span>
            </div>
          </a>
          <div class="dropdown-menu dropdown-menu-right py-0" aria-labelledby="navbarDropdownUser">
            <div class="bg-white rounded-soft py-2" id="navbarDropdownUser">
              <div class="dropdown-item font-weight-bold">{{_authService.firstName()}} {{_authService.lastName()}}</div>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item hoverable" routerLink="/account-settings" (click)="hideCollapse()">Account Settings</a>
              <a class="dropdown-item hoverable cursor-pointer" (click)="editPassword();hideCollapse();">Change Password</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item hoverable cursor-pointer" (click)="logOut()">Logout</a>
            </div>
          </div>
        </li>
      </ul>
    </nav>


    <div class="content" style="margin-left:unset!important;">

      <router-outlet></router-outlet>
      <footer></footer>
      <!-- Modal Password-->
      <div class="modal fade z-index10000 px-0" id="modal_password"
           tabindex="-1" role="dialog" aria-labelledby="modal_password" data-backdrop="static" data-keyboard="true"
           aria-hidden="true">
        <div class="d-flex justify-content-center align-items-center h-100">
          <div class="modal-dialog modal-width-341px" role="document">
            <div class="modal-content">

              <div class="modal-header">
                <h5 class="mb-0 modal-title">Change Password</h5>
                <button class="close" type="button" aria-label="Close" data-dismiss="modal">
                  <span class="font-weight-light" aria-hidden="true">&times;</span>
                </button>
              </div>

              <form [formGroup]="userPasswordForm" (ngSubmit)="onSubmit()">
                <div class="modal-body modal-body-padding">
                  <div class="validation m-0">
                    {{errorPassword}}
                  </div>

                  <div class="form-group">
                    <label for="oldPassword">Old Password <span class="text-danger">*</span></label>
                    <input class="form-control form-control-sm"
                           autocomplete="new-password"
                           id="oldPassword"
                           type="password"
                           formControlName="oldPassword"
                           tabindex="6"
                           autofocus
                           required
                           (keyup)="onPasswordKeyup()">
                  </div>

                  <div class="form-group">
                    <label for="newPassword">New Password <span class="text-danger">*</span></label>
                    <input type="password"
                           id="newPassword"
                           autocomplete="new-password"
                           title="New Password"
                           class="form-control form-control-sm"
                           formControlName="newPassword"
                           tabindex="7"
                           required
                           (keyup)="onPasswordKeyup()" />
                  </div>

                  <div class="form-group">
                    <label for="confirmPassword">Confirm Password <span class="text-danger">*</span></label>
                    <input type="password"
                           id="confirmPassword"
                           autocomplete="new-password"
                           title="Confirm Password"
                           class="form-control form-control-sm"
                           formControlName="confirmPassword"
                           tabindex="8"
                           required
                           (keyup)="onPasswordKeyup()" />
                  </div>

                  <div class="password-validaitons font-size12px mt-2-3">

                    <div class="mt-1 text-danger"
                         *ngIf="userPasswordForm.value.oldPassword &&
                          userPasswordForm.value.newPassword &&
                          userPasswordForm.value.oldPassword == userPasswordForm.value.newPassword">
                      <span class="mr-1">
                        <i class="fas fa-info-circle"></i>
                      </span>
                      Old passwords cannot be reused
                    </div>

                    <div class="mt-1">
                      <span class="mr-1"
                            [ngClass]="(userPasswordForm.value.newPassword?.length >= 8) ? 'text-success' : 'text-muted'">
                        <i class="fas fa-check-circle"></i>
                      </span>
                      Minimum password length is 8
                    </div>

                    <div class="mt-1">
                      <span class="mr-1"
                            [ngClass]="hasPasswordNumber() ? 'text-success' : 'text-muted'">
                        <i class="fas fa-check-circle"></i>
                      </span>
                      At least 1 number
                    </div>

                    <div class="mt-1">
                      <span class="mr-1"
                            [ngClass]="hasPasswordSymbol() ? 'text-success' : 'text-muted'">
                        <i class="fas fa-check-circle"></i>
                      </span>
                      At least 1 symbol
                    </div>

                    <div class="mt-1">
                      <span class="mr-1"
                            [ngClass]="hasPasswordUppercase() ? 'text-success' : 'text-muted'">
                        <i class="fas fa-check-circle"></i>
                      </span>
                      At least 1 uppercase letter
                    </div>

                    <div class="mt-1">
                      <span class="mr-1"
                            [ngClass]="(userPasswordForm.value.newPassword &&
                                  userPasswordForm.value.confirmPassword &&
                                  userPasswordForm.value.newPassword == userPasswordForm.value.confirmPassword) ? 'text-success' : 'text-muted'">
                        <i class="fas fa-check-circle"></i>
                      </span>
                      Password matches Confirm Password
                    </div>

                  </div>
                </div>

                <div class="modal-footer justify-content-end">
                  <div class="row">
                    <div class="col-12">
                      <button class="btn btn-sm btn-falcon-default mr-2" data-dismiss="modal">Close</button>

                      <button class="btn btn-primary float-right btn-sm"
                              contextmenu=""
                              [disabled]="!userPasswordForm.valid ||
                                    userPasswordForm.value.newPassword != userPasswordForm.value.confirmPassword ||
                                    userPasswordForm.value.oldPassword == userPasswordForm.value.newPassword">
                        <div class="g_spinner" *ngIf="spinner"></div>
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
      <!---->


      <div class="modal fade z-index10000 px-0" id="modal_change_password_force"
           tabindex="-1" role="dialog" aria-labelledby="modal_password" data-backdrop="static" data-keyboard="false"
           aria-hidden="true">
        <div class="d-flex justify-content-center align-items-center h-100">
          <div class="modal-dialog modal-width-341px" role="document">
            <div class="modal-content">

              <div class="modal-header">
                <h5 class="mb-0 modal-title">
                  Change Password
                  <br />
                </h5>
              </div>

              <form [formGroup]="userPasswordChangeForceForm" (ngSubmit)="onSubmitForce()">
                <div class="modal-body modal-body-padding">

                  <div class="fs-12 fw-600 text-warning mb-3">
                    For security reasons, you must update your password before continuing.
                  </div>

                  <div class="validation m-0">
                    {{errorPassword}}
                  </div>

                  <div class="form-group">
                    <label for="forceNewPassword">
                      New Password <span class="text-danger">*</span>
                    </label>
                    <input type="password"
                           id="forceNewPassword"
                           autocomplete="new-password"
                           title="New Password"
                           class="form-control form-control-sm"
                           formControlName="newPassword"
                           tabindex="7"
                           autofocus
                           required
                           (keyup)="onPasswordForceKeyup()" />
                  </div>

                  <div class="form-group">
                    <label for="forceConfirmPassword">
                      Confirm Password <span class="text-danger">*</span>
                    </label>
                    <input type="password"
                           id="forceConfirmPassword"
                           autocomplete="new-password"
                           title="Confirm Password"
                           class="form-control form-control-sm"
                           formControlName="confirmPassword"
                           tabindex="8"
                           required
                           (keyup)="onPasswordForceKeyup()" />
                  </div>

                  <div class="password-validaitons font-size12px mt-2-3">

                    <div class="mt-1">
                      <span class="mr-1"
                            [ngClass]="(userPasswordChangeForceForm.value.newPassword?.length >= 8) ? 'text-success' : 'text-muted'">
                        <i class="fas fa-check-circle"></i>
                      </span>
                      Minimum password length is 8
                    </div>

                    <div class="mt-1">
                      <span class="mr-1"
                            [ngClass]="hasForcePasswordNumber() ? 'text-success' : 'text-muted'">
                        <i class="fas fa-check-circle"></i>
                      </span>
                      At least 1 number
                    </div>

                    <div class="mt-1">
                      <span class="mr-1"
                            [ngClass]="hasForcePasswordSymbol() ? 'text-success' : 'text-muted'">
                        <i class="fas fa-check-circle"></i>
                      </span>
                      At least 1 symbol
                    </div>

                    <div class="mt-1">
                      <span class="mr-1"
                            [ngClass]="hasForcePasswordUppercase() ? 'text-success' : 'text-muted'">
                        <i class="fas fa-check-circle"></i>
                      </span>
                      At least 1 uppercase letter
                    </div>

                    <div class="mt-1">
                      <span class="mr-1"
                            [ngClass]="(userPasswordChangeForceForm.value.newPassword &&
                                  userPasswordChangeForceForm.value.confirmPassword &&
                                  userPasswordChangeForceForm.value.newPassword == userPasswordChangeForceForm.value.confirmPassword) ? 'text-success' : 'text-muted'">
                        <i class="fas fa-check-circle"></i>
                      </span>
                      Password matches Confirm Password
                    </div>

                  </div>
                </div>

                <div class="modal-footer justify-content-end">
                  <div class="row">
                    <div class="col-12">
                      <button class="btn btn-primary float-right btn-sm"
                              contextmenu=""
                              [disabled]="!userPasswordChangeForceForm.valid ||
                                    userPasswordChangeForceForm.value.newPassword != userPasswordChangeForceForm.value.confirmPassword">
                        <div class="g_spinner" *ngIf="spinner"></div>
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>


      <!-- Modal Report issue-->
      <div class="modal fade px-0" id="modal_report_issue" tabindex="-1" role="dialog" aria-labelledby="modal_activity" data-backdrop="static" data-keyboard="true" aria-hidden="true">
        <div class="modal-dialog " role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="mb-0 modal-title" id="exampleModalLabel">
                Send feedback
                <br />
              </h5>
              <button class="close" type="button" aria-label="Close" id="X-ModalActivity" data-dismiss="modal">
                <span class="font-weight-light" aria-hidden="true">&times;</span>
              </button>
            </div>
            <div [style.opacity]="spinner ? '0.8;' : '1'">
              <div class="modal-body">
                <div class="row">
                  <div class="col-12 mb-1">
                    <span>Describe your issue or suggestion</span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-group has-feedback">
                      <textarea id="reportIssue" class="form-control font-weight-light" title="Report" alt="Report" placeholder="Tell us how we can improve our software." [(ngModel)]="reportIssue" rows="4" tabindex="1" autofocus maxLength="500"></textarea>
                    </div>
                  </div>
                </div>


                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-group has-feedback">
                      <input type="file" #myfileInput (change)="fileChangeEvent(myfileInput.files)" class="form-control-file form-control-sm p-0" id="myfileInput" tabindex="2" multiple />
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-falcon-default btn-sm" data-dismiss="modal">Close</button>
                <button class="btn btn-sm btn-primary" id="reportSend" (click)="sendReport()" [disabled]="!reportIssue || fileOpe"> Send</button>
              </div>
            </div>
            <ngx-loading [show]="spinner" style="opacity:0.5" class="z-index1000"></ngx-loading>
          </div>
        </div>
      </div>
      <!---->

    </div>
</div>
</main>

